import { keyframes } from '@mui/material';

import { AgenticChatLogo } from '../../../../components/AgenticChat/Logo';

interface AgenticChatActivityIconProps {
  animation: 'Active' | 'Inactive';
}

const activityPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export function AgenticChatActivityIcon(props: AgenticChatActivityIconProps) {
  const { animation } = props;

  return (
    <AgenticChatLogo
      aria-hidden
      sx={{
        fontSize: 16,
        flexShrink: 0,
        color: animation === 'Active' ? 'primary.main' : 'inherit',
        animation: animation === 'Active' ? `${activityPulse} 1.5s ease-in-out infinite` : 'none',
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }}
    />
  );
}
